// STEPS
export const MAIN_DATA_STEP: string = 'data';
export const INFO_STEP: string = 'info';
export const REGISTERS_STEP: string = 'registers';

// MAIN_DATA_STEP
export const NAME_FIELD: string = 'name';
export const EMAIL_FIELD: string = 'email';
export const CREATED_FIELD: string = 'requestDate';
export const DESCRIPTION_FIELD: string = 'description';
export const METHOD_FIELD: string = 'method';
export const REASON_FIELD: string = 'reason';
export const LAST_YEAR_ENROLLMENT_FIELD: string = 'lastYearEnrollment';
export const STUDENT_FIELD: string = 'student';
export const EXTERNAL_FIELD: string = 'external';
export const INTER_DEP_FIELD: string = 'interdepartmental';

// INFO_STEP
export const OBSERVATIONS_FIELD: string = 'observations';
export const RETURN_DATE_FIELD: string = 'returnDate';
export const INTERNAL_NOTES_FIELD: string = 'internalNotes';
export const START_DATE_FIELD: string = 'startDate';
export const END_DATE_FIELD: string = 'endDate';
export const RENEW_DATE_FIELD: string = 'renewDate';
export const RENEW_OBSERVATIONS_FIELD: string = 'renewObservations';
export const ARCHIVIST_FIELD: string = 'archivist';
export const CENTER_FIELD: string = 'center';

// REGISTERS_STEP
export const REGISTERS_FIELD: string = 'registers';